import { formatShortDateWithWeekday } from "@clipboard-health/date-time";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { differenceInDays, parseISO } from "date-fns";
import pluralize from "pluralize";

import { EASY_SCHEDULING_BOOKING_DEADLINE_DAYS } from "../../../api/useGetEasySchedulingPlacements";

interface SentApplicationCardTitleProps {
  appliedDate: string;
  workerTimezone: string;
  variant?: "default" | "easy_scheduling";
  updatedAt?: string;
}

export function SentApplicationCardTitle(props: SentApplicationCardTitleProps) {
  const { appliedDate, workerTimezone, variant = "default", updatedAt } = props;

  if (variant === "easy_scheduling") {
    const dateToUse = updatedAt ?? appliedDate;
    const parsedDate = parseISO(dateToUse);
    const now = new Date();
    const daysSinceUpdated = differenceInDays(now, parsedDate);
    const daysLeft = Math.max(0, EASY_SCHEDULING_BOOKING_DEADLINE_DAYS - daysSinceUpdated);

    return (
      <Text semibold variant="h6">
        Approved: {daysLeft} {pluralize("day", daysLeft)} left to book an interview
      </Text>
    );
  }

  const applicationDate = formatShortDateWithWeekday(appliedDate, {
    timeZone: workerTimezone,
  });

  return (
    <Text semibold variant="h6">
      Applied on {applicationDate}
    </Text>
  );
}
